import {
  OrderServiceItem,
} from '@dapi/sdk';
import {
  createOrderServiceItem,
} from '@dapi/sdk/spec';
import {
  totalPrice,
} from './price';
import {
  MultiUnitPrice,
} from './unit-price';

export const vipOrderServiceItemADT: OrderServiceItem = createOrderServiceItem({template: {
  id: 'TSM16',
  descriptions: [
    {
      type: 'shortText',
      content: 'FASO'
    },
    {
      type: 'longText',
      content: 'FAST PASS'
    }
  ],
  reasonForIssuance: {code: 'E', subCode: 'FP2'},
  quantity: 1,
  flightIds: ['ST1'],
  statusCode: 'UN',
  travelerId: 'TRAVELER-0-MOCK',
  isChargeable: true,
  prices: {
    unitPrices: [MultiUnitPrice],
    totalPrices: [totalPrice]
  },
  details: [
    {
      flightId: 'ST1',
      quantity: 1
    }
  ]
}});

export const vipTransOrderServiceItemADT: OrderServiceItem = createOrderServiceItem({template: {
  id: 'OT49',
  descriptions: [
    {
      type: 'shortText',
      content: 'FASO'
    },
    {
      type: 'longText',
      content: 'FAST PASS'
    }
  ],
  reasonForIssuance: {code: 'E', subCode: 'FP2'},
  quantity: 1,
  flightIds: ['ST2'],
  statusCode: 'HK',
  travelerId: 'PT2',
  isChargeable: true,
  prices: {
    unitPrices: [MultiUnitPrice],
    totalPrices: [totalPrice]
  },
  details: [
    {
      flightId: 'ST1',
      quantity: 1
    }
  ]
}});

export const bagOrderServiceItemOutBoundDisruptADT: OrderServiceItem = createOrderServiceItem({
  template: {
    id: 'TSM46',
    descriptions: [
      {
        type: 'shortText',
        content: 'XBAC'
      },
      {
        type: 'longText',
        content: 'PREPAID EXCESS BAGGAGE FLAT RATE'
      }
    ],
    reasonForIssuance: { code: 'C', subCode: '0H3' },
    quantity: 1,
    flightIds: ['ST1'],
    statusCode: 'UN',
    travelerId: 'TRAVELER-0-MOCK',
    isChargeable: true,
    prices: {
      unitPrices: [MultiUnitPrice],
      totalPrices: [totalPrice]
    },
    details: [
      {
        flightId: 'ST1',
        quantity: 1
      }
    ],
    parameters: [
      {
        code: 'TEXT',
        value: 'TOTAL32KG'
      }
    ]
  }
});

export const bagOrderServiceItemOutBoundDisruptCHD: OrderServiceItem = {
  ...bagOrderServiceItemOutBoundDisruptADT,
  id: 'TSM40',
  travelerId: 'TRAVELER-1-MOCK'
};

export const bagOrderServiceItemInBoundDisruptADT: OrderServiceItem = {
  ...bagOrderServiceItemOutBoundDisruptADT,
  id: 'TSM49',
  flightIds: ['ST2'],
  details: [
    {
      flightId: 'ST2',
      quantity: 1
    }
  ]
};

export const bagOrderServiceItemInBoundDisruptCHD: OrderServiceItem = {
  ...bagOrderServiceItemInBoundDisruptADT,
  id: 'TSM43',
  travelerId: 'TRAVELER-1-MOCK'
};

export const bagOrderServiceItemOutBoundADT: OrderServiceItem = {
  ...bagOrderServiceItemOutBoundDisruptADT,
  id: 'OT109',
  descriptions: [
    {
      type: 'shortText',
      content: 'XBAC'
    }
  ],
  statusCode: 'HK',
  flightIds: ['ST3']
};

export const bagOrderServiceItemOutBoundCHD: OrderServiceItem = {
  ...bagOrderServiceItemOutBoundADT,
  id: 'OT110',
  travelerId: 'TRAVELER-1-MOCK'
};

export const bagOrderServiceItemInBoundADT: OrderServiceItem = {
  ...bagOrderServiceItemOutBoundADT,
  id: 'OT141',
  flightIds: ['ST4']
};

export const bagOrderServiceItemInBoundCHD: OrderServiceItem = {
  ...bagOrderServiceItemInBoundADT,
  id: 'OT142',
  travelerId: 'TRAVELER-1-MOCK'
};

export const bagServiceOutboundCancelled1ADT: OrderServiceItem = {
  id: "TSM24",
  descriptions: [
    {
      type: "shortText",
      content: "FBAG"
    },
    {
      type: "longText",
      content: "EXTRA BAGGAGE"
    }
  ],
  reasonForIssuance: {
    code: "C",
    subCode: "0CC"
  },
  quantity: 1,
  flightIds: [
    "ST1"
  ],
  statusCode: "UN",
  parameters: [
    {
      code: "TEXT",
      value: "TTL1PC"
    }
  ],
  travelerId: "TRAVELER-0-MOCK",
  isChargeable: true,
  prices: {
    unitPrices: [MultiUnitPrice],
    totalPrices: [totalPrice]
  },
  details: [
    {
      flightId: "ST1",
      quantity: 1
    }
  ]
};

export const bagServiceOutboundCancelled1B15: OrderServiceItem ={
  ...bagServiceOutboundCancelled1ADT,
  id:"TSM30",
  travelerId:"TRAVELER-1-MOCK",
};

export const bagServiceinbound1ADT: OrderServiceItem={
  ...bagServiceOutboundCancelled1ADT,
  id: "TSM27",
  statusCode:"HK",
  flightIds: [
    "ST2"
  ],
  details: [
    {
      flightId: "ST2",
      quantity: 1
    }
  ]
};

export const bagServiceinboundB15: OrderServiceItem={
  ...bagServiceOutboundCancelled1ADT,
  id: "TSM33",
  flightIds: [
    "ST2"
  ],
  statusCode:"HK",
  travelerId: "TRAVELER-1-MOCK",
  details: [
    {
      flightId: "ST2",
      quantity: 1
    }
  ]
};



export const bagServiceOutboundNew1ADT: OrderServiceItem = {
  "id": "OT80",
        "descriptions": [
          {
            "type": "shortText",
            "content": "FBAG"
          }
        ],
        "reasonForIssuance": {
          "code": "C",
          "subCode": "0CC"
        },
        "quantity": 1,
        "flightIds": [
          "ST3"
        ],
        "statusCode": "HK",
        "parameters": [
          {
            "code": "TEXT",
            "value": "TTL1PC"
          }
        ],
        "travelerId": "PT2",
        "isChargeable": true,
        "prices": {
          "unitPrices": [
            {
              "prices": [
                {
                  "base": {
                    "value": 4500,
                    "currencyCode": "EUR",
                    currency: {
                      name: 'EURO',
                      decimalPlaces: 2
                    },
                  },
                  "total": {
                    "value": 4500,
                    "currencyCode": "EUR",
                    currency: {
                      name: 'EURO',
                      decimalPlaces: 2
                    },
                  }
                }
              ]
            }
          ],
          "totalPrices": [
            {
              "base": {
                "value": 4500,
                "currencyCode": "EUR",
                currency: {
                  name: 'EURO',
                  decimalPlaces: 2
                },
              },
              "total": {
                "value": 4500,
                "currencyCode": "EUR",
                currency: {
                  name: 'EURO',
                  decimalPlaces: 2
                },
              }
            }
          ]
        }
}

export const bagServiceOutboundNew1B15: OrderServiceItem = {
  "id": "OT81",
        "descriptions": [
          {
            "type": "shortText",
            "content": "FBAG"
          }
        ],
        "reasonForIssuance": {
          "code": "C",
          "subCode": "0CC"
        },
        "quantity": 1,
        "flightIds": [
          "ST3"
        ],
        "statusCode": "HK",
        "parameters": [
          {
            "code": "TEXT",
            "value": "TTL1PC"
          }
        ],
        "travelerId": "PT3",
        "isChargeable": true,
        "prices": {
          "unitPrices": [
            {
              "prices": [
                {
                  "base": {
                    "value": 4500,
                    "currencyCode": "EUR",
                    currency: {
                      name: 'EURO',
                      decimalPlaces: 2
                    },
                  },
                  "total": {
                    "value": 4500,
                    "currencyCode": "EUR",
                    currency: {
                      name: 'EURO',
                      decimalPlaces: 2
                    },
                  }
                }
              ]
            }
          ],
          "totalPrices": [
            {
              "base": {
                "value": 4500,
                "currencyCode": "EUR",
                currency: {
                  name: 'EURO',
                  decimalPlaces: 2
                },
              },
              "total": {
                "value": 4500,
                "currencyCode": "EUR",
                currency: {
                  name: 'EURO',
                  decimalPlaces: 2
                },
              }
            }
          ]
        }
}

export const mealOrderServiceItemADT: OrderServiceItem = createOrderServiceItem({template: {
  id: 'TSM18',
  descriptions: [
    {
      type: 'shortText',
      content: 'GPML'
    },
    {
      type: 'longText',
      content: 'GOURMET FISH MEAL'
    }
  ],
  reasonForIssuance: {code: 'G', subCode: '02F'},
  quantity: 1,
  flightIds: ['ST1'],
  statusCode: 'UN',
  travelerId: 'TRAVELER-0-MOCK',
  isChargeable: true,
  prices: {
    unitPrices: [MultiUnitPrice],
    totalPrices: [totalPrice]
  },
  details: [
    {
      flightId: 'ST1',
      quantity: 1
    }
  ]
}});


export const mealOrderServiceItemADT2: OrderServiceItem = {
  ...mealOrderServiceItemADT,
  id: 'TSM21',
  travelerId: 'TRAVELER-1-MOCK'
};

export const mealOrderServiceItemTransferredADT: OrderServiceItem = {
  ...mealOrderServiceItemADT,
  id: 'OT57',
  statusCode: 'KK',
  travelerId: 'TRAVELER-0-MOCK',
  descriptions: [
    {
      type: 'shortText',
      content: 'GPML'
    }
  ],
  flightIds: ['ST3']
};

export const mealOrderServiceItemTransferredADT2: OrderServiceItem = {
  ...mealOrderServiceItemTransferredADT,
  id: 'OT58',
  travelerId: 'TRAVELER-1-MOCK'
};

export const sportsOrderServiceItemADT: OrderServiceItem = createOrderServiceItem({template: {
  id: 'TSM24',
  descriptions: [
    {
      type: 'shortText',
      content: 'KITE'
    },
    {
      type: 'longText',
      content: 'KITE SURFBOARD'
    }
  ],
  reasonForIssuance: {code: 'C', subCode: '0G0'},
  quantity: 1,
  flightIds: ['ST1'],
  statusCode: 'UN',
  travelerId: 'TRAVELER-0-MOCK',
  isChargeable: true,
  prices: {
    unitPrices: [MultiUnitPrice],
    totalPrices: [totalPrice]
  },
  details: [
    {
      flightId: 'ST1',
      quantity: 1
    }
  ]
}});


export const sportsOrderServiceItemADT2: OrderServiceItem = {
  ...sportsOrderServiceItemADT,
  id: 'TSM27',
  travelerId: 'TRAVELER-1-MOCK'
};

export const sportsOrderServiceItemSTU: OrderServiceItem = {
  ...sportsOrderServiceItemADT,
  id: 'TSM21',
  travelerId: 'TRAVELER-2-MOCK'
};

export const sportsOrderTransferredServiceItemADT: OrderServiceItem = createOrderServiceItem({template: {
  id: 'OT78',
  descriptions: [
    {
      type: 'shortText',
      content: 'KITE'
    }
  ],
  reasonForIssuance: {code: 'C', subCode: '0G0'},
  quantity: 1,
  flightIds: ['ST3'],
  statusCode: 'HK',
  travelerId: 'TRAVELER-0-MOCK',
  isChargeable: true,
  prices: {
    unitPrices: [MultiUnitPrice],
    totalPrices: [totalPrice]
  }
}});

export const sportsOrderTransferredServiceItemADT2: OrderServiceItem = {
  ...sportsOrderTransferredServiceItemADT,
  id: 'OT79',
  travelerId: 'TRAVELER-1-MOCK'
};

export const sportsOrderTransferredServiceItemSTU: OrderServiceItem = {
  ...sportsOrderTransferredServiceItemADT,
  id: 'OT77',
  travelerId: 'TRAVELER-2-MOCK'
};